<template>
    <div class="">
        <form :action="targetUrl" method="POST">
            <input :value="csrf" name="_token" type="hidden" />
            <input name="_return_redirect" type="hidden" value="false" />
            <install-wizard-card>
                <template #top-header>
                    Report Setup
                </template>
                <template #top-content>
                    Subscribe groups to receive our most popular reports, delivered automatically to their inbox. <br/>

                    By default Excursion Reports are sent monthly and Point Summary Reports are sent Weekly.<br/>

                    The frequency of reports can be changed once the site is completely activated.<br/>

                    Once the site is fully activated, you can also leverage SoniCloud to view these reports on-demand.


<!--                    Subscribe users to receive our most popular reports, delivered automatically to their inbox on a weekly basis.<br/>-->
<!--                    Users can also leverage SoniCloud to view these reports on-demand once you're up and running.<br/>-->
<!--                    The frequency of reports can be changed once the site is completely activated.-->
                </template>

                <template #body-summary>
                    <!-- User is Sonicu and report setup has been completed; show a warning to avoid overwriting settings -->
                    <div    v-if="permissions.isSonicu() && reportSetupCompleted"
                            class="px-4 sm:px-12">
                        <p  class="mt-1 max-w-2xl text-sm leading-5 text-yellow-700">
                            You should use this for initial configuration of Group Reporting only.
                            Do not use it after group reporting has been configured, as previous settings
                            can be overwritten.
                        </p>
                    </div>
                </template>

                <template #body-action>
                    <div class="px-4 sm:px-12">
                        <!-- Excursion Report -->
                        <div class="pb-8">
                            <div class="">
                                <div    class="pb-4">
                                    <p class="text-lg leading-6 font-medium text-gray-900">
                                        Excursion Report
                                    </p>
                                    <p class="py-2 mt-1 max-w-2xl text-sm leading-5 text-gray-500">
                                        This report gives you the daily minimum, maximum, twice daily data readings,
                                        a graphical summary, and a list of excursions.<br/>

                                        This is ideal for users who want a regulatory compliance focused report
                                        delivered to them automatically.
                                    </p>
                                </div>
                                <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                                    <label
                                            class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                        Groups to receive Excursion Report
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <div class="max-w-xs rounded-md shadow-sm">
                                            <select2
                                                    :multiple="true"
                                                    :options="groups"
                                                    :value="excursionGroupsSelected"
                                                    name="report_excursion_groups[]"
                                            >
                                            </select2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Device Summary Report Settings -->
                        <div class="">
                            <div class="">
                                <div    class="pb-4">
                                    <p class="text-lg leading-6 font-medium text-gray-900">
                                        Point Summary Report
                                    </p>
                                    <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
                                        This is a management focused report that shows minimum, maximum,
                                        average readings, and alarms.<br/>

                                        This helps provide an easily understandable overview of the status
                                        of your SoniCloud system.
                                    </p>
                                </div>

                                <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                                    <label
                                            class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                        Groups to receive Point Summary Report
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <div class="max-w-xs rounded-md shadow-sm">
                                            <select2
                                                    :multiple="true"
                                                    :options="groups"
                                                    :value="pointSummaryGroupsSelected"
                                                    name="report_point_summary_groups[]"
                                            >
                                            </select2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

                <template #bottom-header>
                    Done automating sending reports to groups?
                </template>
                <!--            <template #bottom-button-text></template>-->
                <template #bottom-button>
                    <a>
                        <button class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-blue-200 focus:border-blue-700 active:bg-blue-700"
                                type="submit">
                            <slot name="bottom-button-text">Save Report Settings!</slot>
                        </button>
                    </a>
                </template>
            </install-wizard-card>
        </form>
    </div>
</template>

<script>
    import InstallWizardCard from "./InstallWizardCard";
    import Select2 from "@/components/elements/select2";
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
    import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary.vue";
    import SlideOverPanel from "@/components/elements/SlideOverPanel.vue";
    import TemplateReport from "@/components/Reports/TemplateReport.vue";

    export default {
        name: "InstallWizardReportSetup",
        mixins: [SonicuCoreMixin],
        props: {
            groups: {
                type: Object,
                default() {
                    return {}
                },
            },
            pointSummaryGroupsSelected: {
                type: Object,
                default: function() { return {} }
            },
            excursionGroupsSelected: {
                type: Object,
                default: function() { return {} }
            },
            reportSetupCompleted: {
                type: Boolean,
                default: false,
            },
            route: String,
        },
        data() {
            return {

            }
        },
        components: {
            TemplateReport,
            SlideOverPanel, ButtonBlueSecondary, Select2, InstallWizardCard},
        methods: {
        },
        computed: {
            targetUrl(){
                return this.company.buildCompanyRoute('wizard/'+this.route);
            },
        },
        watch: {
        }
    }
</script>

<style scoped>

</style>